import { gql } from '$lib/apollo';

export const GET_NAV_GAME = gql`
  query GetNavGame($slug: String, $id: UUID) {
    game(slug: $slug, id: $id) {
      id
      slug
      postCount
      localizedTitles {
        en
      }
      localizedShortTitles {
        en
      }
      logoMain {
        original {
          url
        }
      }
      poster {
        original {
          url
        }
      }
      seoData {
        title
        description
      }
      communityArtwork {
        id
        name
        artwork {
          original {
            url
          }
        }
        socialAccounts {
          website
          twitter
          instagram
          devianart
          artstation
        }
      }
      artwork {
        original {
          url
        }
      }
    }
  }
`;

export const GET_COMMUNITIES = gql`
  query GetCommunities($first: Int) {
    currentSession {
      id
      communities(first: $first) {
        edges {
          node {
            id
            position
            record {
              ... on API_Follow {
                id
                game {
                  id
                  slug
                  localizedTitles {
                    en
                  }
                  logoMain {
                    original {
                      url
                    }
                  }
                  communityArtwork {
                    id
                    artwork {
                      original {
                        url
                      }
                    }
                    socialAccounts {
                      website
                      twitter
                      instagram
                      devianart
                      artstation
                    }
                  }
                  artwork {
                    original {
                      url
                    }
                  }
                }
              }
              ... on API_GroupMember {
                id
                role
                group {
                  id
                  title
                  slug
                  logo {
                    original {
                      url
                    }
                  }
                  account {
                    id
                    slug
                    avatar {
                      original {
                        url
                      }
                    }
                  }
                  membership {
                    id
                    newPostsCount
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_FOLLOWING_GAMES = gql`
  query GetFollowingGames($first: Int = 100) {
    currentSession {
      id
      follows(type: GAME, first: $first) {
        totalCount
        edges {
          node {
            id
            position
            game {
              id
              slug
              localizedTitles {
                en
              }
              logoMain {
                original {
                  url
                }
              }
              communityArtwork {
                id
                artwork {
                  original {
                    url
                  }
                }
                socialAccounts {
                  website
                  twitter
                  instagram
                  devianart
                  artstation
                }
              }
              artwork {
                original {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;
